// extracted by mini-css-extract-plugin
module.exports = {"option":"DataItem_option__3hYXJ","param":"DataItem_param__GMw2Q"};